module.exports = __webpack_public_path__ + "media/images/icon_bgc_blue-1c18abb58b8e9c846aec0882027c8ff0.png";